import api from "@/services/api"
import { queryClient } from "@/queryClient"
import { BASE_CASHIERS_QUERY_KEY } from "@/services/queryKeys"

export const deleteCashier = async (
  cashierId: string
): Promise<unknown> => {
  const response = await api.delete(
    `/cashiers/${cashierId}/`
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_CASHIERS_QUERY_KEY],
  })
  return response.body
}
